<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">PERSONEL YETKİ YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchAuthorisation = !showSearchAuthorisation">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Personel Yetki Arama</span>
        </h2>

        <div v-if="showSearchAuthorisation" class="card-bg p-5">
          <form @submit.prevent="getUserAuthorisation()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Personel Yetki Id</b></label>
                <vs-input size="large" type="number" style="width: 100%;" v-model="userAuthorisationSearch.userAuthorisationId" />
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Yetki Adı</b></label>
                <v-select @input="getUserAuthorisation()" name="Id" v-model="userAuthorisationSearch.authorisationId" placeholder="Yetki Adı" :options="authorisationList" label="name" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Personel</b></label>
                <v-select @input="getUserAuthorisation()" name="Id" v-model="userAuthorisationSearch.userId" placeholder="Personel" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>
      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddAuthorisation = !showAddAuthorisation">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6" /></span><span>Personel Yetkisi Oluştur</span>
        </h2>
        <div v-if="showAddAuthorisation" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Personel</b></label>
                <v-select name="Id" v-model="userAuthorisationItem.userId" placeholder="Personel" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
            <div class="right flex-1">
              <div class="left flex-1">
                <div class="mb-5">
                  <label class="text-sm"><b>Yetki</b></label>
                  <v-select name="Id" v-model="userAuthorisationItem.authorisationId" placeholder="Yetki Adı" :options="authorisationList" label="name" class="w-full" :reduce="(row) => row.id">
                    <span slot="no-options">Eşleşen Veri Yok</span>
                  </v-select>
                </div>
              </div>
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-220" @click="SaveAuthorisation(userAuthorisationItem, 'Insert', '')">Personel Yetkisi Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Personel Yetkileri</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="userAuthorisationList">
            <template slot="thead">
              <vs-th>Personel Yetki Id</vs-th>
              <vs-th>Personel</vs-th>
              <vs-th>Yetki</vs-th>
              <vs-th>Tarih</vs-th>
              <vs-th>İşlemler</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.userAuthorisationId">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.userAuthorisationId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <v-select name="Id" v-model="tr.userId" placeholder="Personel" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <v-select name="Id" v-model="tr.authorisationId" placeholder="Yetki Adı" :options="authorisationList" label="name" class="w-full" :reduce="(row) => row.id">
                      <span slot="no-options">Eşleşen Veri Yok</span>
                    </v-select>
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.date }}</b>
                  </vs-td>

                  <vs-td style="width: 10%;">
                    <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 w-6 hover:text-warning text-danger cursor-pointer" @click.stop="SaveAuthorisation(tr, 'Delete', 'Personel Yetkisi Silinecektir')" />
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveAuthorisation(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      userAuthorisationItem: { userAuthorisationId: null, userId: null, userName: null, authorisationId: null, authorisationName: null, date: null },
      userAuthorisationList: [],
      userList: [],
      authorisationList: [],
      authorisationSearch: { id: null },
      userAuthorisationSearch: { userAuthorisationId: null, userId: null, authorisationId: null },
      userAuthorisationItem: { userAuthorisationId: null, userId: null, authorisationId: null },
      showAddAuthorisation: false,
      showSearchAuthorisation: false,
    };
  },

  computed: {},
  methods: {
    getAuthorisation: async function () {
      this.$vs.loading();
      this.authorisationList = await repository.postEntity("ParametricScreens/getAuthorisation", this.authorisationSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getUserAuthorisation: async function () {
      this.$vs.loading();
      this.userAuthorisationList = await repository.postEntity("ParametricScreens/getUserAuthorisation", this.userAuthorisationSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getUsers: async function () {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },

    SaveAuthorisation: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveUserAuthorisation", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.userAuthorisationItem = {};
      this.userAuthorisationSearch = {};
      this.getUserAuthorisation();
    },
  },
  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getAuthorisation(), this.getUserAuthorisation(), this.getUsers()]);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}

</style>
